import React from "react";
import { Box, Table, Thead, Tbody, Th, Tr, Td, useColorModeValue } from "@chakra-ui/react";

const TableFixedHeader = ({ 
  children, 
  data = [],
  columns = [],
  maxHeight = "100%",
  size = "xs",
  variant = "simple",
  minHeight = 0,
  tableMinHeight = 0,
  ...props 
}) => {
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <Box maxHeight={maxHeight} minHeight={minHeight} overflow="hidden" display="flex" flexDirection="column" {...props}>
      <Box flexShrink={0} overflow="hidden">
        <Table variant={variant} w="100%" size={size} tableLayout="fixed">
          <Thead position="sticky" top={0} bg="white" zIndex={1}>
            <Tr>
              {columns.map((column, index) => (
                <Th 
                  key={index}
                  borderColor={borderColor} 
                  color="black" 
                  w={column.width || "auto"} 
                  fontSize="14px"
                  {...column.headerProps}
                >
                  {column.header}
                </Th>
              ))}
            </Tr>
          </Thead>
        </Table>
      </Box>
      
      <Box flex="1" overflow="auto" minHeight={tableMinHeight}>
        <Table variant={variant} w="100%" size={size} tableLayout="fixed">
          <Tbody>
            {data.map((row, rowIndex) => (
              <Tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <Td 
                    key={colIndex}
                    borderColor={borderColor}
                    fontSize="14px"
                    w={column.width || "auto"}
                    {...column.cellProps}
                  >
                    {column.render ? column.render(row, rowIndex) : row[column.key]}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      
      {children}
    </Box>
  );
};

export default TableFixedHeader;
